import Swiper, {Navigation, Pagination} from 'swiper';

export default () => {

    document.querySelectorAll('.subscr-sect__slider').forEach((slider) => {

        new Swiper(slider, {
            modules: [Navigation, Pagination],
            wrapperClass: 'slider__slides',
            slideClass: 'slider__slide',
            slidesPerView: 'auto',
            navigation: {
                prevEl: slider.querySelector('.slider__nav__item._prev'),
                nextEl: slider.querySelector('.slider__nav__item._next')
            },
            pagination: {
                el: slider.querySelector('.slider__pagination')
            }
        });

    });

}